
















































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import LearningCourse from "@/store/entities/article";
import url from "@/lib/url";
//import ewebeditor from "@/components/ewebeditor.vue";

@Component({
  components: {},
})
export default class EditLearningCourse extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  learningCourse: LearningCourse = new LearningCourse();
  editorContentConfig: any = {
    style: 'gray',
    width: '100%',
    height: '500px'
  };
  frontendurl: string = 'https://manage.sxjy.cq.cn/dist/ewebeditor/';
  editorBackendurl: string = 'https://manage.sxjy.cq.cn/dist/ewebeditor/';
  formTitle: string = "课程管理发布";
  isCreate: boolean = true;
  data: any = [];
  valueArray: any = [];
  parentId?: number;
  parentName: string = "一级分类";
  uploadActin: string = url + "api/services/app/File/FileGetToken";
  token: string = "Bearer " + window.abp.auth.getToken();
  uploadList: any = [];
  uploadPdfList: any = [];
  content: string = "";
  chapters: any = [];
  chapterId: string = "";
  chapterTypeAndContent: any = [];
  temporaryChapterId: string = "";
  screenWidth: number = document.body.clientWidth - 200;
  mobilescreenWidth: string = "100%";
  // setEditorData() {
  //   (this.$refs["ewe"] as any).setHtmleweb(this.content);
  // }
  chapterChange(val) {
    this.saveConfirm(this.temporaryChapterId);
    this.selectChapter(val);
  }
  selectChapter(id) {
    // (this.$refs["ewe"] as any).setHtmleweb("");
    this.content = "";
    this.chapterTypeAndContent.forEach((item) => {
      if (item.chapterTypeId == id) {
        this.content = item.learningContent;

      }
    });
    this.temporaryChapterId = id;
  }
  saveConfirm(id) {
    //  let isHave = false;
    // console.log(this.chapterTypeAndContent);
    //    this.content = (this.$refs["ewe"] as any).getHtmleweb();
    if (this.temporaryChapterId) {
      this.chapterTypeAndContent.forEach((item, index) => {
        if (item.chapterTypeId == id) {
          this.chapterTypeAndContent[index].learningContent = this.content;
          //   item.learningContent = this.content;
          // isHave = true;
        }
      });
      // if (!isHave) {
      //  let chapterAndContent = {
      //    chapterTypeId: id,
      //   learningContent: this.content,
      //  };
      //  this.chapterTypeAndContent.push(chapterAndContent);
      //}
    }
  }
  uploadSuccess(res, file, fileList) {
    this.uploadList = fileList;
  }

  handleRemove(file, fileList) {
    this.uploadList = fileList;
  }
  handleMaxSize(file) {
    this.$Notice.warning({
      title: "超出文件大小限制",
      desc: "文件【" + file.name + "】 太大, 不能超过50M.",
    });
  }
  cascaderSelect(value, selectedData) {
    if (selectedData.length < 2) {
      this.chapterTypeAndContent = [];
    }
    if (selectedData.length > 0)
      this.learningCourse.categoryId = selectedData[selectedData.length - 1].id;
    else this.learningCourse.categoryId = null;
    if (selectedData.length == 3) {
      this.getChapter(selectedData[2].id);
    }
  }
  async getChapter(typeId: number) {
    await this.$store.dispatch({
      type: "learningCourse/getChapters",
      data: { categoryId: typeId },
    });
    this.chapters = this.$store.state.learningCourse.chapterTypes.items;
    if (this.chapters.length > 0) {
      this.chapterId = this.chapters[0].id;
      this.temporaryChapterId = this.chapterId;
      this.chapters.forEach((item) => {
        const newOut = {
          // 关键！ 创建一个新对象
          chapterTypeId: item.id, // 将循环拿到的属性循环赋值给newOut.A0000
          learningContent: "",
        };
        this.chapterTypeAndContent.push(newOut); // 循环赋值好的对象 push到 集合中
      });
      // let chapterAndContent = { chapterTypeId: this.chapterId, learningContent: this.learningCourse.content }
      // this.chapterTypeAndContent.push(chapterAndContent)
    }
  }
  async updategetChapter(typeId: number) {
    let chapterAndContent =
      this.$store.state.learningCourse.editLearningCourse.chapterTypeAndContent;
    // this.chapterTypeAndContent = chapterAndContent;
    let upchapterTypeAndContent = [];
    let _this = this;

    await this.$store
      .dispatch({
        type: "learningCourse/getupChapters",
        data: { categoryId: typeId },
      })
      .then((result) => {
        this.chapters = result.items;
        if (this.chapters.length > 0) {
          this.chapterId = this.chapters[0].id;
          this.temporaryChapterId = this.chapterId;
          this.chapters.forEach((item, index) => {
            const newOut = {
              // 关键！ 创建一个新对象
              chapterTypeId: item.id, // 将循环拿到的属性循环赋值给newOut.A0000
              learningContent: "",
              chapterTypeName: item.name,
            };
            upchapterTypeAndContent.push(newOut); // 循环赋值好的对象 push到 集合中
          });
          if (chapterAndContent.length > 0) {
            _this.chapterTypeAndContent = _this.foreachchaper(
              upchapterTypeAndContent,
              chapterAndContent
            );
          } else {
            _this.chapterTypeAndContent = upchapterTypeAndContent;
          }
        }
      })
      .catch((err) => { });
  }
  foreachchaper(data, chapterAndContent) {
    data.forEach((item, index) => {
      chapterAndContent.forEach((items, indexs) => {
        if (items.chapterTypeId == item.chapterTypeId) {
          data[index].learningContent =
            chapterAndContent[indexs].learningContent;
        }
      });
    });
    return data;
  }

  save() {
    (this.$refs.learningCourseForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.valueArray.length > 0) {
          if (this.valueArray.length < 3) {
            this.$Message.warning("分类未选择到末级!");
            return false;
          }
        } else {
          this.$Message.warning("请选择文章分类");
          return false;
        }
        if (!this.learningCourse.title) {
          this.$Message.warning("请填写文章标题");
          return false;
        }
        // if (!this.learningCourse.issued) {
        //  this.$Message.warning("请填写文章来源");
        //  return false;
        //  }
        //  if (!this.learningCourse.author) {
        //  this.$Message.warning("请填写文章作者");
        //   return false;
        // }
        this.learningCourse.gradeType = 1;
        this.saveConfirm(this.temporaryChapterId);
        if (this.chapterTypeAndContent.length > 0)
          this.learningCourse.chapterTypeAndContent =
            this.chapterTypeAndContent;
        else this.learningCourse.content = this.content;
        // console.log(this.learningCourse);
        let sendType = "learningCourse/update";
        if (this.isCreate) {
          sendType = "learningCourse/create";
        }
        await this.$store.dispatch({
          type: sendType,
          data: this.learningCourse,
        });
        if (this.isCreate) {
          this.content = "";
          this.learningCourse.title = "";
          this.chapterTypeAndContent = [];
          // this.chapters = [];
          this.chapters.forEach((item) => {
            const newOut = {
              // 关键！ 创建一个新对象
              chapterTypeId: item.id, // 将循环拿到的属性循环赋值给newOut.A0000
              learningContent: "",
            };
            this.chapterTypeAndContent.push(newOut); // 循环赋值好的对象 push到 集合中
          });
          this.learningCourse.testPaperId = "";
          this.learningCourse.description = "";
          this.learningCourse.isAllShow = false;
          this.learningCourse.isExport = false;
        } else {
          (this.$refs.learningCourseForm as any).resetFields();
          this.$emit("save-success");
          this.$emit("input", false);
        }
      }
    });
  }
  cancel() {
    this.visibleChange(false);
    this.chapters = [];
  }
  visibleChange(value: boolean) {
    this.content = "";
    this.temporaryChapterId;
    this.learningCourse = new LearningCourse();
    if (!value) {
      this.chapterTypeAndContent = [];
      this.$store.state.learningCourse.editLearningCourse = this.learningCourse;
      (this.$refs.learningCourseForm as any).resetFields();
      if (this.isCreate) this.$emit("save-success");
      this.$emit("input", value);
    } else {
      this.data = this.$store.state.learningCourse.cascaders.items;
      this.learningCourse = Util.extend(
        true,
        {},
        this.$store.state.learningCourse.editLearningCourse
      );
      if (this.learningCourse.id) {
        this.isCreate = false;
        this.formTitle = "课程管理修改";
        this.valueArray =
          this.$store.state.learningCourse.editLearningCourse.categoryList;
        let chapterAndContent =
          this.$store.state.learningCourse.editLearningCourse
            .chapterTypeAndContent;
        this.chapterTypeAndContent = chapterAndContent;

        if (chapterAndContent.length > 0) {
          this.content = chapterAndContent[0].learningContent;
          this.temporaryChapterId = chapterAndContent[0].chapterTypeId;
        } else
          this.content =
            this.$store.state.learningCourse.editLearningCourse.content;
        if (this.valueArray.length >= 3)
          this.updategetChapter(this.valueArray[2]);

      } else {
        this.chapters = [];
        this.isCreate = true;
        this.formTitle = "课程管理发布";
        this.valueArray = [];
        this.content = "";
        this.learningCourse.content = "";

        //(this.$refs["ewe"] as any).setHtmleweb("");
      }
    }
  }
  validateNameList = (rule, value, callback) => {
    if (value.length === 0) {
      callback(new Error("请选择name"));
    } else {
      callback();
    }
  };
  learningCourseRule = {};
}
// 校验输入的字符长度
function lenValid(str, num, cb) {
  if (str) {
    let len = str.length;
    if (len > num) {
      return cb(new Error("Too Long..."));
    }
  }
  cb();
}
